export default __webpack_public_path__ + "static/media/trophy-confetti.11dad24d.svg";